import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings -> Easeedesk -> Assigning workflows (v4/api, `App\Settings\
 * Easeedesk\EaseedeskAssigningWorkflows`). Forma paginii e inghetata in
 * `settings/easeedesk/__fixtures__/assigningWorkflows.json`.
 */
export interface AssignedWorkflowRow {
  ID: number
  type_name: string
  short_name: string
  color_identifier: string
  workflow_id: number
  takeover_button: number
}

export interface AssigningWorkflowsPage {
  assigned_workflows: AssignedWorkflowRow[]
  workflows: { ID: number; workflow_name: string }[]
}

export function assigningWorkflowsQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'assigning_workflows'],
    queryFn: () => apiGet<AssigningWorkflowsPage>('/settings/easeedesk/assigning_workflows'),
  })
}

/** `Easeedesk::assign_workflow` - `ticket_type` + `workflow_id`. */
export function assignWorkflow(ticketType: number, workflowId: string) {
  return apiPost<{ status: string }>('/settings/easeedesk/assigning_workflows/assign', {
    ticket_type: String(ticketType),
    workflow_id: workflowId,
  })
}

/** `Easeedesk::change_ticket_takeover` - `take_over=on` numai cand e bifat, ca formularul vechi. */
export function changeTicketTakeover(ticketType: number, on: boolean) {
  const fields: Record<string, string> = { ticket_type: String(ticketType) }
  if (on) fields.take_over = 'on'
  return apiPost<{ status: string }>('/settings/easeedesk/assigning_workflows/takeover', fields)
}
